import { render } from "./HiTab.vue?vue&type=template&id=2f4d7899"
import script from "./HiTab.vue?vue&type=script&lang=js"
export * from "./HiTab.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__